import cn from 'classnames';
import styles from './recirculation.module.scss';

interface Props {
    borderColor?: string;
    className?: string;
    children: React.ReactNode | React.ReactNode[];
    isDarkTheme?: boolean;
}

export default function Recirculation({
    borderColor = 'var(--off-white)',
    className = '',
    children,
    isDarkTheme,
}: Props): React.ReactNode {
    const containerStyles = cn(styles.recirculation, {
        [styles.darkTheme]: isDarkTheme,
    });

    return (
        <div
            className={`${className} ${containerStyles}`}
            style={isDarkTheme ? {} : { borderColor }}
            data-cy="molecules-recirculation-body"
            data-recirculation
        >
            {children}
        </div>
    );
}
